import React from "react";
import SimpleButton from "../../atoms/simple-button/SimpleButton";
import classes from "./MisaBrandEmptyState.module.scss";
import rabbitWalking from "../../static/images/common/char-wailking.svg";

type Props = {
  onSelectBrand: () => void;
};

const MisaBrandEmptyState = ({ onSelectBrand }: Props) => {
  return (
    <div className={classes.emptyCard}>
      <div className={classes.emptyMessage}>
        <img src={rabbitWalking} alt="応援したい銘柄" />
        <p>
          まずは推しを選んで
          <br />
          応援してください
        </p>
      </div>
      <SimpleButton
        label="推しを選ぶ"
        width="100%"
        color="orange"
        isRadius={true}
        onClick={onSelectBrand}
      />
    </div>
  );
};

export default MisaBrandEmptyState;
